export default "__VITE_ASSET__DIwrb44K__"